import type { SupplierRecordChromeProps } from './supplier-record-chrome';
import { AppLayout } from '@/widgets/app-layout';
import { SupplierRecordChrome } from './supplier-record-chrome';

// The record page's outer frame. All of the chrome — persistent header, status
// line, actions, tab strip — lives in `SupplierRecordChrome`, rendered OUTSIDE
// the tab panels so it survives every tab switch (spec §2). This wrapper only
// adds the app layout and breadcrumbs.
export const SupplierRecordShell = (props: SupplierRecordChromeProps) => (
  <AppLayout activeItem="crm" breadcrumbs={['Crm', 'Accounts', props.name]}>
    <SupplierRecordChrome {...props} />
  </AppLayout>
);
